import { render } from "./FinancialStatement.vue?vue&type=template&id=8c2c4c38&scoped=true"
import script from "./FinancialStatement.vue?vue&type=script&lang=js"
export * from "./FinancialStatement.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c2c4c38"]])

export default __exports__